import { createSlice } from '@reduxjs/toolkit';
import { addQuestionPaper, generateSectionA, getEachQuestionPaper, getITQuestionDetailInfo, getQuesTemplateDetail, getQuestionDetailInfo, getQuestionPaper, getQuestionPaperDetail, getQuestionTemplate, removeQuestionPaper, saveQuestionTemplate } from 'services/store/actions/questionPaperAction';

interface QusPaperState {
    loading: boolean;
    questionpaperData: any; // Define the type of userInfo
    error: any; // Define the type of error
    success: boolean;
    loading1: boolean;
    addPaperInfo: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    removePaperInfo: any;
    error2: any;
    success2: boolean;
    //get question data
    loading3: boolean;
    quesPaperInfo: any;
    error3: any;
    success3: boolean;
    //get each question
    loading4: boolean;
    paperInfo: any;
    error4: any;
    success4: boolean;
    loading5: boolean;
    section1Info: any;
    error5: any;
    success5: boolean;
    loading6: boolean;
    error6: any;
    success6: boolean;
    quespaprInfo: any;
    loading9: boolean;
    success9: boolean;
    error9: any;
    itQuesInfo: any;
    loading10: boolean;
    error10: any;
    success10: boolean;
    saveTemplateInfo: any;
    loading11: boolean;
    success11: boolean;
    error11: any;
    templateInfo: any;
    loading12: boolean;
    success12: boolean;
    error12: any;
    templateDetailInfo: any;
}

const initialState: QusPaperState = {
    loading: false,
    questionpaperData: null,
    error: null,
    success: false,
    loading1: false,
    addPaperInfo: null,
    error1: null,
    success1: false,
    loading2: false,
    removePaperInfo: null,
    error2: null,
    success2: false,
    //each question paper
    success3: false,
    loading3: false,
    quesPaperInfo: null,
    error3: null,
    loading4: false,
    paperInfo: null,
    error4: null,
    success4: false,
    loading5: false,
    error5: null,
    success5: false,
    section1Info: null,
    loading6: false,
    error6: null,
    success6: false,
    quespaprInfo: null,
    loading9: false,
    error9: null,
    success9: false,
    itQuesInfo: null,
    loading10: false,
    error10: null,
    success10: false,
    saveTemplateInfo: null,
    loading11: false,
    error11: null,
    success11: false,
    templateInfo: null,
    loading12: false,
    success12: false,
    error12: null,
    templateDetailInfo: null,
};

const questionpaperSlice = createSlice({
    name: 'questionspaper',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getQuestionPaper.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getQuestionPaper.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.questionpaperData = payload;
                state.success = true;
            })
            .addCase(getQuestionPaper.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            // addquestionbank user
            .addCase(addQuestionPaper.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(addQuestionPaper.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.success1 = true;
                state.addPaperInfo = payload;
            })
            .addCase(addQuestionPaper.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.success1 = false;
                state.error1 = payload;
            })
            // deletequestionbank user
            .addCase(removeQuestionPaper.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(removeQuestionPaper.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.success2 = true;
                state.removePaperInfo = payload;
            })
            .addCase(removeQuestionPaper.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.success2 = false;
                state.error2 = payload;
            })
            //each question paper
            .addCase(getEachQuestionPaper.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(getEachQuestionPaper.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.success3 = true;
                state.quesPaperInfo = payload;
            })
            .addCase(getEachQuestionPaper.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.success3 = false;
                state.error3 = payload;
            })
            //get each question paper detail
            .addCase(getQuestionPaperDetail.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
            })
            .addCase(getQuestionPaperDetail.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.success4 = true;
                state.paperInfo = payload;
            })
            .addCase(getQuestionPaperDetail.rejected, (state, { payload }) => {
                state.loading4 = false;
                state.success4 = false;
                state.error4 = payload;
            })
            .addCase(generateSectionA.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
                state.section1Info = null;
            })
            .addCase(generateSectionA.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.success5 = true;
                state.section1Info = payload;
            })
            .addCase(generateSectionA.rejected, (state, { payload }) => {
                state.loading5 = false;
                state.success5 = false;
                state.error5 = payload;
            })
            .addCase(getQuestionDetailInfo.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
                state.quespaprInfo = null;
            })
            .addCase(getQuestionDetailInfo.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.success6 = true;
                state.quespaprInfo = payload;
            })
            .addCase(getQuestionDetailInfo.rejected, (state, { payload }) => {
                state.loading6 = false;
                state.success6 = false;
                state.error6 = payload;
            })
            .addCase(getITQuestionDetailInfo.pending, (state) => {
                state.loading9 = true;
                state.error9 = null;
                state.success9 = false;
                state.itQuesInfo = null;
            })
            .addCase(getITQuestionDetailInfo.fulfilled, (state, { payload }) => {
                state.loading9 = false;
                state.success9 = true;
                state.itQuesInfo = payload;
            })
            .addCase(getITQuestionDetailInfo.rejected, (state, { payload }) => {
                state.loading9 = false;
                state.success9 = false;
                state.error9 = payload;
            })
            .addCase(saveQuestionTemplate.pending, (state) => {
                state.loading10 = true;
                state.error10 = null;
                state.success10 = false;
                state.saveTemplateInfo = null;
            })
            .addCase(saveQuestionTemplate.fulfilled, (state, { payload }) => {
                state.loading10 = false;
                state.success10 = true;
                state.saveTemplateInfo = payload;
            })
            .addCase(saveQuestionTemplate.rejected, (state, { payload }) => {
                state.loading10 = false;
                state.success10 = false;
                state.error10 = payload;
            })
            .addCase(getQuestionTemplate.pending, (state) => {
                state.loading11 = true;
                state.error11 = null;
                state.success11 = false;
                state.templateInfo = null;
            })
            .addCase(getQuestionTemplate.fulfilled, (state, { payload }) => {
                state.loading11 = false;
                state.success11 = true;
                state.templateInfo = payload;
            })
            .addCase(getQuestionTemplate.rejected, (state, { payload }) => {
                state.loading11 = false;
                state.success11 = false;
                state.error11 = payload;
            })
            .addCase(getQuesTemplateDetail.pending, (state) => {
                state.loading12 = true;
                state.error12 = null;
                state.success12 = false;
                state.templateDetailInfo = null;
            })
            .addCase(getQuesTemplateDetail.fulfilled, (state, { payload }) => {
                state.loading12 = false;
                state.success12 = true;
                state.templateDetailInfo = payload;
            })
            .addCase(getQuesTemplateDetail.rejected, (state, { payload }) => {
                state.loading12 = false;
                state.success12 = false;
                state.error12 = payload;
            });
    },
});
export default questionpaperSlice.reducer;
